import React, { useRef, useState } from "react";
import FluentUiIcon from "../../../../../assets/fluent-ui-icon";
import { FluentInput } from "../../../../../components/FluentUI/Fluent-Input";
import ChatSuggestion from "./chat-suggestion";
import ChatHeader from "./chat-header";
import ChatMessageUser from "./chat-message-user";
import ChatMessageAssistant from "./chat-message-assistant";
import FluentSpinner from "../../../../../components/FluentUI/Fluent-Spinner";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import PropTypes from "prop-types";
import { scrollToBottomById } from "../../../../../util/general-helpers";

export default function Chat({ data, setShowForm, suggestions }) {

  const ref = useRef(0);
  const [chatMessages, setChatMessages] = useState([
    {
      role: "assistant",
      content: "Hi, I am TRIYO AI Assistant. What can I assist you with today?",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");

  const FetchAssistantData = async (prompt) => {
    setLoading(true);

    return fetch("https://api.openai.com/v1/chat/completions", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${import.meta.env.VITE_OPEN_AI_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        model: window["APP_SETTINGS"].REACT_APP_OPEN_AI_MODEL,
        messages: [
          {
            role: "system",
            content: `You answer questions based on a provided context.
            You answer questions as thoroughly as possible using only the provided context that is the audit of the tasks.
            If the context doesn't provide an answer, you indicate that.`,
          },
          {
            role: "user",
            content: `${prompt}
            ${data}'`,
          },
        ],
      }),
    }).then((response) => {
      return response
        .json()
        .then((data) => {
          setLoading(false);
          return data;
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    });
  };

  const FetchUserData = async (suggestion) => {
    setChatMessages((prev) => [
      ...prev,
      {
        role: "user",
        content: suggestion.message,
      },
    ]);

    if (data) {
      let data = await FetchAssistantData(suggestion.prompt);
      setChatMessages((prev) => [
        ...prev,
        { role: "assistant", content: data.choices[0].message.content },
      ]);
    } else {
      setChatMessages((prev) => [
        ...prev,
        {
          role: "assistant",
          content: "No comments found.",
        },
      ]);
    }

    scrollToBottomById("chat-conversation-identifier");
  };

  const OnInput = async () => {
    let suggestion = {
      text: "",
      prompt: `${value}. Provide the answer from the following content:`,
      message: value,
    };

    setChatMessages((prev) => [
      ...prev,
      { role: "user", content: suggestion.message },
    ]);
    setValue("");
    scrollToBottomById("chat-conversation-identifier");

    let data = await FetchAssistantData(suggestion.prompt);
    setChatMessages((prev) => [
      ...prev,
      { role: "assistant", content: data.choices[0].message.content },
    ]);
    scrollToBottomById("chat-conversation-identifier");
  };

  const OnKeyDown = (e) => {
    if (e.key === "Enter") {
      OnInput();
      ref.current++;
    }
  };

  return (
    <div className="d-flex flex-column chat-container mb-4">
      <div className="d-flex align-align-items-center chat-header">
        <ChatHeader setShowForm={setShowForm}></ChatHeader>
      </div>
      <div
        id="chat-conversation-identifier"
        className="d-flex flex-column chat-conversation overflow-auto mt-2"
      >
        {chatMessages.map((message) =>
          message.role === "assistant" ? (
            <ChatMessageAssistant
              key={message.content}
              message={message.content}
            />
          ) : (
            <ChatMessageUser key={message.content} message={message.content} />
          )
        )}
      </div>
      <div className="d-flex chat-suggestions mt-2">
        {suggestions?.map((suggestion) => (
          <ChatSuggestion
            text={suggestion.text}
            onClick={() => FetchUserData(suggestion)}
          />
        ))}
      </div>
      <div className="chat-input d-flex align-items-center mt-2 justify-content-between">
        <div className="chat-input-text w-100">
          <FluentInput
            placeholder={"Enter question..."}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => OnKeyDown(e)}
            key={ref.current}
          ></FluentInput>
        </div>
        <FluentProvider theme={webLightTheme}>
          <div
            className="d-flex justify-content-center align-items-center chat-input-button"
            onClick={OnInput}
          >
            {loading ? (
              <FluentSpinner />
            ) : (
              <FluentUiIcon name={"SendRegular"} color={"#fff"} size={18} />
            )}
          </div>
        </FluentProvider>
      </div>
    </div>
  );
}

Chat.propTypes = {
  comments: PropTypes.string,
  setShowForm: PropTypes.func.isRequired,
};
